import React from 'react';
import { StyleSheet, css } from 'aphrodite';
import { Theme } from '../../config/theme';

let styles;
const APP_DOWNLOAD_ICON = require('./app-download-icon.png');
const IOS_ICON = require('./ios.png');
const ANDROID_ICON = require('./android.png');

export default () => (
  <div className={css(styles.container)}>
    <div className={css(styles.information)}>
      <img
        src={APP_DOWNLOAD_ICON}
        alt="Add to your homescreen"
        className={css(styles.appDownloadIcon)}
      />
      <div className={css(styles.copy)}>
        <h2 className={css(styles.heading)}>Is there a Dog Share app?</h2>
        You can add the website bookmark to your phone&apos;s home screen, and it operates just like
        an app! Click the icon of your mobile OS for instructions.
      </div>
    </div>
    <div className={css(styles.information)}>
      <a
        rel="noopener noreferrer"
        href="https://www.macrumors.com/how-to/add-a-web-link-to-home-screen-iphone-ipad/#:~:text=Launch%20Safari%20on%20your%20%E2%80%8CiPhone%E2%80%8C,tap%20Add%20to%20Home%20Screen."
        target="_blank"
      >
        <img src={IOS_ICON} alt="Supported on iOS" className={css(styles.osIcon)} />
      </a>
      <a
        rel="noopener noreferrer"
        href="https://support.google.com/android/answer/9450271?hl=en#zippy=%2Cadd-an-app"
        target="_blank"
      >
        <img src={ANDROID_ICON} alt="Supported on Android" className={css(styles.osIcon)} />
      </a>
    </div>
  </div>
);

styles = StyleSheet.create({
  container: {
    padding: '5px 0',
    textAlign: 'center',
    backgroundColor: Theme.white,
    border: `1px solid ${Theme.horizontal_rule_color}`,

    [Theme.mobile_query]: {
      padding: '25px 0 35px',
    },
  },
  heading: {
    marginBottom: 5,
    fontFamily: Theme.font_family_secondary,
    fontSize: 15,
    letterSpacing: 2,
    textTransform: 'uppercase',
    fontWeight: Theme.font_weight_heading,
    lineHeight: 1.73,
    color: '#000e1f',
  },
  appDownloadIcon: {
    maxWidth: 100,
    maxHeight: 100,
  },
  information: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    margin: '0 auto 8px',

    [Theme.mobile_query]: {
      width: 'auto',
      flexWrap: 'wrap',
      justifyContent: 'center',
    },
  },
  copy: {
    position: 'relative',
    textAlign: 'left',
    lineHeight: 1.73,
    padding: '0 5px',

    [Theme.mobile_query]: {
      textAlign: 'center',
    },
  },
  osIcon: {
    maxWidth: 40,
    maxHeight: 40,
    margin: '0 10px',
    opacity: 1,
    transition: 'all 300ms',

    ':hover': {
      opacity: 0.6,
    },
  },
});



// WEBPACK FOOTER //
// ./src/components/AppDownloadInformation/index.js